import VueCharts from "vue-chartjs";
import { Bar, Line, Pie, Doughnut } from "vue-chartjs";
export default {
  extends: Doughnut,
  props: {
    labels: {},
    data: {},
  },

  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: ["#9e76b4", "#bf72b1", "#de6ea6", "#f86c93", "#ff7079", "#ff7d5c", "#ff8f3a", "#ffa600", "#003f5c", "#d45087"],
            data: this.data,
          },
        ],
      },
      {
        title: {
          display: false,
          text: "",
        },
        scales: {
          //   yAxes: [
          //     {
          //       ticks: {
          //         beginAtZero: true,
          //       },
          //       scaleLabel: {
          //         display: true,
          //         labelString: this.yAxisLabel,
          //       },
          //     },
          //   ],
          //   xAxes: [
          //     {
          //       stacked: true,
          //       categoryPercentage: 0.5,
          //       barPercentage: 1,
          //     },
          //   ],
        },
        plugins: {
          datalabels: {
            color: "#ffffff",
            font: {
              size: 12,
            },
            formatter: (value) => {
              return value + ' คน';
            }
          },
        },
        legend: {
          display: true,
          align: 'start'
        },
        tooltips: {
          callbacks: {
            title: (item, data) => data.labels[item[0].index],
            label: (item, data) => `${data.datasets[0].data[item.index]} คน`
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    );
  },
  watch: {},
};
